import { Box, Flex } from "@jewlr/storybook/core"
import { FloatInput, FloatSelect } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

import { InputWrapper, SectionTitle, Text } from "areas/order/components"
import { jewlr_t } from "helpers/application"

const ShipAddress = ({ control, shipData }) => (
  <Box pt={2}>
    <SectionTitle>Shipping Address</SectionTitle>
    <Text mb={2}>
      Please verify the address you would like the ring shipped back to after
      its resizing.
    </Text>

    <Flex flexDirection={{ _: "column", desktop: "row" }}>
      <Box mr={{ desktop: 2 }}>
        <InputWrapper>
          <Controller
            control={control}
            name="address1"
            render={({ field, fieldState: { error } }) => (
              <FloatInput
                error={error}
                label="Street Address"
                variant="checkout"
                {...field}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Controller
            control={control}
            name="address2"
            render={({ field, fieldState: { error } }) => (
              <FloatInput
                error={error}
                label="Apartment/Suite Number (Optional)"
                variant="checkout"
                {...field}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Controller
            control={control}
            name="postal_code"
            render={({ field, fieldState: { error } }) => (
              <FloatInput
                error={error}
                label={shipData.postal_label}
                variant="checkout"
                {...field}
              />
            )}
          />
        </InputWrapper>
      </Box>
      <Box>
        <InputWrapper>
          <Controller
            control={control}
            name="city"
            render={({ field, fieldState: { error } }) => (
              <FloatInput
                error={error}
                label="Town/City"
                variant="checkout"
                {...field}
              />
            )}
          />
        </InputWrapper>
        {shipData.has_states ? (
          <InputWrapper>
            <Controller
              control={control}
              name="state"
              render={({ field, fieldState: { error } }) => (
                <FloatSelect
                  error={error}
                  label={jewlr_t("address.state")}
                  variant="checkout"
                  {...field}
                >
                  <option disabled value="">
                    {jewlr_t("address.state")}
                  </option>
                  {shipData.state_options.map((state, i) => (
                    <option key={`state${i}`} value={state.code}>
                      {state.name}
                    </option>
                  ))}
                </FloatSelect>
              )}
            />
          </InputWrapper>
        ) : (
          <InputWrapper>
            <Controller
              control={control}
              name="state"
              render={({ field }) => <input type="hidden" {...field} />}
            />
          </InputWrapper>
        )}
      </Box>
    </Flex>
  </Box>
)

ShipAddress.propTypes = {
  control: PropTypes.object,
  shipData: PropTypes.object,
}

export default ShipAddress
